class MessageGroupRequest {
  static create = {
    messageGroupParticipant1: null,
    messageGroupParticipant2: null
  };
  static update = {
    messageGroupId: null,
    messageGroupParticipant1: null,
    messageGroupParticipant2: null,
    messageGroupStatus: null
  };

  static readBy = {
    messageGroupId: null
  };

  static readByCustomerId = {
    customerId: null
  };
}

export default MessageGroupRequest;
